import { render, staticRenderFns } from "./ModalPedidoPreview.vue?vue&type=template&id=323e4436&scoped=true"
import script from "./ModalPedidoPreview.vue?vue&type=script&lang=js"
export * from "./ModalPedidoPreview.vue?vue&type=script&lang=js"
import style0 from "./ModalPedidoPreview.vue?vue&type=style&index=0&id=323e4436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323e4436",
  null
  
)

export default component.exports